'use client';
import React from 'react';
import addMonths from 'date-fns/addMonths';

import Layout from '../lib/components/Layout';
import CalendarService from '../lib/services/CalendarService';
import ColumnsDefinition from './ColumnsDef';
import { formatRequestDate, injectLogos } from '../lib/utils';
import { ICalendarProps, IDateRange } from '../lib/interfaces';
import { fetchStockSplits } from './Services';
import { Splits } from '@benzinga/calendar-manager';

export const StockSplitsColumnsDef = ColumnsDefinition;
export const fetchStockSplitsData = fetchStockSplits;

export const StockSplitsCalendar: React.FC<ICalendarProps> = ({
  calendar,
  calendarData,
  hasStockTableStyling,
  height,
  initialData,
  initialDateRange,
  initialTicker,
  leftSlot,
  onReady,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [tableData, setTableData] = React.useState<Splits[]>(initialData || []);
  let dateRange: IDateRange;

  React.useEffect(() => {
    if (calendarData?.serverSide) {
      setTableData(initialData);
    }
  }, [initialData, calendarData]);

  if (initialDateRange) {
    dateRange = initialDateRange;
  } else {
    dateRange = {
      date_from: formatRequestDate(new Date()),
      date_to: formatRequestDate(addMonths(new Date(), 1)),
    };
  }

  function onTableReady() {
    if (initialData) {
      setTableData(initialData);
    } else {
      const params = {
        'parameters[date_from]': dateRange.date_from,
        'parameters[date_search_field]': 'ex',
        'parameters[date_sort]': 'ex',
        'parameters[date_to]': dateRange.date_to,
      };
      if (initialTicker) {
        params['parameters[tickers]'] = initialTicker;
      }
      fetchData(params);
    }

    if (onReady) {
      setTimeout(() => onReady());
    }
  }

  function fetchData(filterParams: any) {
    const query = {
      ...filterParams,
      pagesize: 1000,
    };

    setLoading(true);

    const Calendar = new CalendarService();

    Calendar.getSplits(query)
      .then(({ data }: any) => {
        const items: any = [];
        if (Array.isArray(data.splits) && data.splits.length) {
          return injectLogos(data.splits);
        }
        return items;
      })
      .then((items: any) => {
        setTableData(items);
        setLoading(false);
      });
  }

  return (
    <Layout
      calendar={calendar}
      calendarData={calendarData}
      columnDefs={ColumnsDefinition}
      defaultAdditionalParams={{ date_search_field: 'ex', date_sort: 'ex' }}
      enableSearch
      hasStockTableStyling={hasStockTableStyling}
      height={height}
      initialDateRange={dateRange}
      leftSlot={leftSlot}
      onFilterChanged={fetchData}
      onTableReady={onTableReady}
      tableData={tableData}
      tableLoading={loading}
      ticker={initialTicker}
    />
  );
};
